import React from 'react';

import {TextHeader, ViewRow} from './layout/PDFLayout';
import {BaselinePDFProjectType} from './BaselinePDFTypes';

type BaselinePDFHeaderProps = {
	project: BaselinePDFProjectType;
};
const BaselinePDFHeader = ({project}: BaselinePDFHeaderProps): JSX.Element => {
	return (
		<ViewRow style={{justifyContent: 'space-between', alignItems: 'center', paddingBottom: '8px'}}>
			<TextHeader style={{width: '80%'}}>{project.name}</TextHeader>
		</ViewRow>
	);
};

export default BaselinePDFHeader;
